import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';

export const useDeleteQuotation = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return fetchJson(`/quotations/draft/${id}`, {
        method: 'DELETE',
      });
    },
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: QueryKeys.quotations.show.id(id) });

      return queryClient.invalidateQueries({ queryKey: QueryKeys.quotations.index.root });
    },
  });
};
